import { render, staticRenderFns } from "./SubscriptionForm.vue?vue&type=template&id=fa0eada8&scoped=true&"
import script from "./SubscriptionForm.vue?vue&type=script&setup=true&lang=js&"
export * from "./SubscriptionForm.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./SubscriptionForm.vue?vue&type=style&index=0&id=fa0eada8&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa0eada8",
  null
  
)

export default component.exports